// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx"}[chunkId] || chunkId) + "-" + {"108":"04df86f298586cb68db5","245":"8e9ba25cf5735a7eed8c","452":"e6f1c92f7caff043fc81","453":"f948bc88b070891a346c"}[chunkId] + ".js";
};